import { interfaces } from 'inversify'
import { Ref } from 'vue'

import { ActiveParticipant } from './ActiveParticipant'

type SI<T> = interfaces.ServiceIdentifier<T>

interface HandballRelationIoCBindingsInterface {
  ActiveParticipant: SI<Ref<ActiveParticipant>>
}

export const HandballRelationIoCBindings: HandballRelationIoCBindingsInterface =
  { ActiveParticipant: Symbol('ActiveParticipant') }
